(function() {
  //skip script on other pages
  if (!document.querySelector('div[data-forms-id="forms-root-354816"]')) {
    return;
  }
  
  // find shadow-root
  function tryInit() {
  const host = document.querySelector('shopify-forms-embed#app-embed');
    if (!host || !host.shadowRoot) return false;
    const root = host.shadowRoot;

    // mapping inputs
    const map = {
      inpost:     root.querySelector('#custom\\#kod_paczkomatu_inpost_1'),
      postal:     root.querySelector('#custom\\#kod_pocztowy'),
      city:       root.querySelector('#custom\\#miasto'),
      address:    root.querySelector('#custom\\#adres'),
    };
    // find containers
    const fields = {};
    for (let key in map) {
      const inp = map[key];
      if (inp && inp.parentElement) fields[key] = inp.parentElement;
    }
    
    if (Object.keys(fields).length === 0) return false;

    // dropdown
    const btn = root.querySelector('button[aria-controls^="custom#opcja_dostawy"]');
    const txt = btn?.querySelector('span[class*="selectToggleText"]');
    if (!txt) return false;

    // show/hide
    function update() {
      const v = txt.textContent.trim().toLowerCase();

      // hide everything
      Object.values(fields).forEach(el => el.style.display = 'none');

      // remove "required" from the InPost field by default
      if (map.inpost) map.inpost.removeAttribute('required');

      if (v.includes('inpost')) {
        // show parcel locker field
        fields.inpost.style.removeProperty('display');
        // set as mandatory
        if (map.inpost) map.inpost.setAttribute('required', 'required');
      } else if (v.includes('kurierska')) {
        ['postal','city','address'].forEach(k => fields[k].style.removeProperty('display'));
      }
    }

    // hide and observe changes
    Object.values(fields).forEach(el => el.style.display = 'none');
    update();
    new MutationObserver(update)
      .observe(txt, { childList: true, subtree: true, characterData: true });


    // TRACK FORM SUBMIT EVENT
    const form = root.querySelector('form');

    // if (form) {
    //   form.addEventListener('submit', () => {
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({
    //       event: 'form_probki_tkanin'
    //     });
    //   }, { once: true });
    // }

    if (form) {
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        const v = txt.textContent.trim().toLowerCase();

        // Walidacja tylko dla InPost
        if (v.includes('inpost') && (!map.inpost || !map.inpost.value.trim())) {
          e.stopImmediatePropagation(); // zatrzymaj inne eventy (w tym Shopify)
          e.preventDefault(); // nie wysyłaj formularza
          alert('Podaj kod paczkomatu InPost.');
          map.inpost.focus();
          return false;
        }

        // Jeśli wszystko OK, dopiero wyślij event do dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_probki_tkanin'
        });
      }, true); // Uwaga: TRUE -> capture mode, łapie event zanim Shopify
    }
  }

    return true;
  }

  // poll until ready
  (function poll() {
    console.log('polling');
    if (!tryInit()) requestAnimationFrame(poll);
  })();
})();
